import * as React from 'react';
import styled from 'styled-components';
import pencil from '../../../images/pencil.svg';

const EditButton = ({ onClick }: Props) => (
	<Button title="Edit" className="iconButton editIcon editButton" type="button" onClick={onClick}>
		<img src={pencil} alt="Edit Icon" />
	</Button>
);

interface Props {
	onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default EditButton;

const Button = styled.button`
	cursor: pointer;
`;
